export var Salinity;
(function (Salinity) {
    Salinity["Normal"] = "1";
    Salinity["High"] = "2";
    Salinity["VeryHigh"] = "3";
})(Salinity || (Salinity = {}));
